module.exports = __webpack_public_path__ + "static/media/POSINKU_MENU-normal.be9651a1.png";